import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon } from 'components/common';

type Props = {
  text: string,
  severity?: 'warning' | 'info',
}

const StyledText = styled.p`
  margin-bottom: 0;
`;

const Violation = ({ text, severity }: Props) => {
  switch (severity) {
    case 'warning':
      return (<StyledText><Icon name="warning" className="text-danger" /> {text}</StyledText>);
    case 'info':
      return (<StyledText>{text}</StyledText>);
    default:
      return (<StyledText><Icon name="check" className="text-success" /> {text}</StyledText>);
  }
};

Violation.propTypes = {
  text: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(['warning', 'info']),
};

Violation.defaultProps = {
  severity: undefined,
};

export default Violation;
